import { ApiErrorResponseWithCode } from '@vfde-sails/utils';
import { ActionType, CaptchaMediaType } from './enum';
import {
    CaptchaState,
    FormDataType,
    SalesLeadErrorResponse,
    SalesLeadResponse,
    StateProps,
} from './interface';

export const initStore = (state: Partial<StateProps>) => ({
    type: ActionType.INIT_STORE,
    state,
} as const);

export const changeInput = (update: FormDataType) => ({
    type: ActionType.CHANGE_INPUT,
    update,
} as const);

export const submitForm = () => ({
    type: ActionType.SUBMIT_FORM,
} as const);

export const handleLMSResponse = (
    payload: SalesLeadResponse | null,
    error?: SalesLeadErrorResponse | null
) => ({
    type: ActionType.HANDLE_LMS_RESPONSE,
    payload,
    error,
} as const);

/** Send a get request to get a captcha */
export const getCaptcha = (captchaMediaType: CaptchaMediaType) => ({
    type: ActionType.GET_CAPTCHA,
    captchaMediaType,
} as const);

export const handleCaptchaResponse = (
    captchaState: CaptchaState | null,
    errorResponse?: ApiErrorResponseWithCode
) => ({
    type: ActionType.HANDLE_CAPTCHA_RESPONSE,
    captchaState,
    error: errorResponse,
} as const);

export type Actions = ReturnType<typeof initStore>
    | ReturnType<typeof changeInput>
    | ReturnType<typeof getCaptcha>
    | ReturnType<typeof submitForm>
    | ReturnType<typeof handleLMSResponse>
    | ReturnType<typeof handleCaptchaResponse>;
